import React from 'react';
import { AlertDialog, AlertDialogBody, AlertDialogCloseButton, AlertDialogContent, AlertDialogFooter, AlertDialogHeader, AlertDialogOverlay, Button, Spinner, useDisclosure, useToast } from '@chakra-ui/react';
import { useParams, useNavigate } from "react-router-dom";
import { useFetch } from '../../contexts/FetchContext';
import ResponseHandler, { Responses } from '../../components/Helpers/ResponseHandler';


export const ValidateLicense = () => {
    const cancelRef = React.useRef<HTMLButtonElement>(null);

    const navigate = useNavigate();

    const toast = useToast();

    const { tableName, tableId } = useParams();

    const { licenseIt } = useFetch();

    const onClose = () => {
        navigate(-1);
    };

    const invalidateLicense = (tableId: string) => {
        licenseIt.validateLicense(tableId)
        .then(response => {
            ResponseHandler(`Sucessfully validated license 🤘`, Responses.Success, toast);
            onClose();
        }).catch(error => {
            ResponseHandler("Could not validate license: "+error, Responses.Error, toast);
            onClose();
        })
    }
    
    return (
        tableName && tableId ? (
            <AlertDialog
                motionPreset='slideInBottom'
                leastDestructiveRef={cancelRef}
                onClose={onClose}
                isOpen={true}
                isCentered
            >
                <AlertDialogOverlay/>
                <AlertDialogContent>
                    <AlertDialogHeader>Validate {tableName}?</AlertDialogHeader>
                    <AlertDialogCloseButton/>
                    
                    <AlertDialogBody>
                        Are you sure you want to validate {tableName}?
                    </AlertDialogBody>
    
                    <AlertDialogFooter>
                        <Button colorScheme='grey' variant='ghost' ref={cancelRef} onClick={onClose}>Cancel</Button>
                        <Button colorScheme='blue' ml={3} onClick={() => invalidateLicense(tableId)}>Validate</Button>
                    </AlertDialogFooter>
                </AlertDialogContent>
            </AlertDialog>
        ) : (
            <Spinner/>
        )
    )
}

